import React from "react";
import NavbarSection from "../NavbarSection/NavbarSection";
import HeroDataSection from "../HeroDataSection/HeroDataSection";
import carbg from "../../assets/carbg.png";
import "./HeroCab.css"
import { Link } from "react-router-dom";
const HeroCab = () => {
  return (
    <div className="hero-main-div">
      <div
        className="hero-background-image-div"
        style={{ backgroundImage: `url(${carbg})` }}
      ></div>

      <div className="hero-content">
        <NavbarSection />
        <HeroDataSection />
        <div className="hero-button-div">
      <Link to="/adventure-cab-view-more"><button>Explore Car</button></Link>
         <Link to="/motor-cycle"><button>Explore Bike</button></Link>
         <Link to="/scooter-ride"><button>Explore Scooter</button></Link>
        </div>
      </div>
    </div>
  );
};

export default HeroCab;
